import { render, staticRenderFns } from "./RecoveryFee.vue?vue&type=template&id=7ba624b4&scoped=true&"
import script from "./RecoveryFee.vue?vue&type=script&lang=js&"
export * from "./RecoveryFee.vue?vue&type=script&lang=js&"
import style0 from "./RecoveryFee.vue?vue&type=style&index=0&id=7ba624b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba624b4",
  null
  
)

export default component.exports